import type { AspectRatio, SizeOptions } from '@uncinc/react-drupal-core/dist/Components/DynamicMediaItem';
import type { SearchAllContentHit, SearchAllContentImageRatio } from '../components/SearchAllContent/types';

function constructImageSourcesArray(
  hit: SearchAllContentHit,
  aspectRatio: AspectRatio,
) {
  // Do not omit the xxs size, otherwise we always render an image that is 1 size too large.
  const sizeOptions: SizeOptions[] = ['xxs', 'xs', 'sm', 'md'];

  // For indexing image ratios, we use custom fields in the ES index.
  // The tokens for this differ between entity type.
  const prefix = hit.entity_type[0] === 'profile' ? 'profile_' : '';

  const sources = sizeOptions
    .map((size) => {
      const imageRatio = `${prefix}image_ratio_${aspectRatio}_${size}` as SearchAllContentImageRatio;
      const imageStyle = hit[imageRatio] as [string] | undefined;
      return imageStyle?.[0];
    })
    .filter((source) => source !== undefined);

  return sources;
}

export default constructImageSourcesArray;
